import { Avatar, Card, Col, Divider, Flex, Row } from "antd";
import { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as UserIcon } from "../../../assets/icon/userIcon.svg";
import styles from "../styles/EmployeeMenu.module.css";

function EmployeeInfoTab() {

    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    // const { currentCompany, currentEmployee } = useSelector((state) => state.company);
    // const isPortrait = useMediaQuery({ orientation: 'portrait' })
    // const isTabletOrMobile = useMediaQuery({ maxWidth: 1224 })
    // const { roles } = useSelector((state) => state.company);
    // const isOver = useMediaQuery({ maxWidth: 1000 })

    const employmentInfo = useSelector(
        (state) => state.employee.currentEmploymentInProfile
    );
    const generalInfo = useSelector((state) => state.employee.currentEmployee);
    const currentContactInfo = useSelector((state) => state.employee.currentContactInfo);
    const { remainingLeave, employeeWorkInCount } = useSelector((state) => state.employee);

    const [getInfo, setGetInfo] = useState({});
    const language = i18n.language == 'en' ? "En" : ""

    const convertLeaveHour = (remainingLeaveHour) => {
        const leaveHour = parseFloat(remainingLeaveHour);
        if (leaveHour !== 0) {
            const decimalPart = leaveHour % 1;
            const convertedMinutes = (decimalPart * 60) / 100;
            return `${(Math.floor(leaveHour) + convertedMinutes).toFixed(2)} ${t("unit.hours")}`;
        }
        return `0.00 ${t("unit.hours")}`;
    };

    useEffect(() => {
        let language = i18n.language === "en" ? "En" : "";
        const newInfo = {
            employeeImage: generalInfo?.employeeImage,
            positionName: generalInfo?.position?.["name" + language] ?? "",
            employeeNo: generalInfo?.employeeNo ?? "",
            name: generalInfo?.["name" + language] ?? "",
            surName: generalInfo?.["surName" + language] ?? "",
            departmentName: employmentInfo?.department?.["name" + language] ?? "",
            email: employmentInfo?.email ?? "",
            status: employmentInfo?.employeeStatus?.["name" + language] ?? "",
            shift: employmentInfo?.shift?.["name" + language] ?? "",
            position: employmentInfo?.position?.["name" + language] ?? "",
            company: employmentInfo?.company?.["name" + language] ?? "",
            branch: employmentInfo?.branch?.["name" + language] ?? "",
            mobile: currentContactInfo?.mobileNumber ?? ""
        };
        setGetInfo(newInfo);
    }, [generalInfo, employmentInfo, currentContactInfo, i18n.language]);

    return (
        <Card
            style={{
                borderRadius: "8px",
                backgroundColor: "#FCFCFC",
                border: "1px solid #EAECF0",
                height: "100%",

            }}>
            <Flex vertical style={{
                rowGap: "24px",

            }}>
                <Flex>
                    <Col span={6}>
                        <Flex vertical align="center" >
                            <Avatar
                                size={70}
                                src={getInfo?.employeeImage ? "data:image/png;base64," + getInfo.employeeImage : <UserIcon />}
                            // icon={!getInfo?.employeeImage && <UserOutlined />}
                            />
                            <span style={{ fontSize: "16px" }}>
                                {getInfo?.name ? getInfo?.name + " " + getInfo?.surName : "-"}
                            </span>
                        </Flex>
                        <Flex vertical style={{ marginTop: "16px" }}>
                            <span style={{ color: "#667085" }}>
                                {t("employee.label.employee_no")} : {getInfo?.employeeNo ? getInfo?.employeeNo : "-"}
                            </span>
                            <span style={{ color: "#667085" }}>
                                {t("home.email")} : {getInfo?.email ? getInfo?.email : "-"}
                            </span>
                            <span style={{ color: "#667085" }}>
                                {t("mobile-no-0")} : {getInfo?.mobile ? getInfo?.mobile : "-"}
                            </span>
                            <span style={{ color: "#667085" }}>
                                {t("employee.label.department")} : {getInfo?.departmentName ? getInfo?.departmentName : "-"}
                            </span>
                            <span style={{ color: "#667085" }}>
                                {t("employee.label.position")} : {getInfo?.position ? getInfo?.position : "-"}
                            </span>
                            <span style={{ color: "#667085" }}>
                                {t("employee.label.work-location")} : {getInfo?.branch ? getInfo?.branch : "-"}
                            </span>

                        </Flex>
                    </Col>
                    <Col span={1} style={{ textAlign: "center" }}>
                        <Divider type="vertical" className={styles.customDivider} style={{ height: "100%" }} />
                    </Col>
                    <Col span={13} style={{ alignSelf: "center" }}>
                        <Row style={{ marginBottom: "24px" }}>
                            <span style={{ color: "#42526D" }}>{t("employee.leave_benefit_remain")}</span>
                        </Row>
                        <Row justify={"space-around"}>
                            {remainingLeave?.map((leave, index) => {
                                const remainingDay = leave?.remainingLeaveDays !== 0 ? `${leave?.remainingLeaveDays} ${t("unit.day")}` : ""
                                const remainingHour = leave?.remainingLeaveHour !== "0.00" ? convertLeaveHour(leave?.remainingLeaveHour) : ""

                                return (
                                    <Col key={index} span={5} style={{ display: "flex", flexDirection: "column", rowGap: "10px", alignItems: "center" }}>
                                        {/* <Card style={{ borderRadius: "50%", border: "solid 1px #E4E7EC", width: "80px", height: "80px", textAlignLast: "center" }}>
                                            <span style={{ color: "#42526D", fontSize: leave?.unlimited == "Y" ? "24px" : "20px", fontWeight: "bold" }}>{leave?.unlimited == "Y" ? "∞" : `${remainingDay} ${remainingHour}`}</span>
                                        </Card> */}
                                        <Card style={{ borderRadius: "50%", border: "solid 1px #E4E7EC", width: "80px", height: "80px", textAlignLast: "center" }}>
                                            <span style={{ color: "#42526D", fontSize: leave?.unlimited == "Y" ? "24px" : "20px", fontWeight: "bold" }}>{leave?.unlimited == "Y" ? "∞" : leave?.remainingLeaveDays}</span>
                                        </Card>
                                        <Flex vertical>
                                            <span style={{ color: "#667085", textAlign: "center" }}>{leave?.["leaveTypeName" + language]}</span>
                                            <span style={{ textAlign: "center" }}>{leave?.unlimited == "Y" ? t("unlimited") : leave?.totalLeaveDays + " " + t("unit.days")} </span>
                                        </Flex>
                                    </Col>)
                            })}
                        </Row>
                    </Col>
                    <Col span={1} style={{ textAlign: "center" }}>
                        <Divider type="vertical" className={styles.customDivider} style={{ height: "100%" }} />
                    </Col>
                    <Col span={3} style={{ alignSelf: "center" }}>
                        <Row style={{ marginBottom: "16px" }}>
                            <Col span={12} style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ color: "var(--button-color)", fontSize: "20px", fontWeight: "bold", textAlign: "center" }}>{employeeWorkInCount?.checkInEarly}</span>
                                <span style={{ color: "#667085", textAlign: "center" }}>{t("home.eary_come")}</span>
                            </Col>
                            <Col span={12} style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ color: "var(--button-color)", fontSize: "20px", fontWeight: "bold", textAlign: "center" }}>{employeeWorkInCount?.checkInLate}</span>
                                <span style={{ color: "#667085", textAlign: "center" }}>{t("home.late")}</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12} style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ color: "var(--button-color)", fontSize: "20px", fontWeight: "bold", textAlign: "center" }}>{employeeWorkInCount?.checkOutEarly}</span>
                                <span style={{ color: "#667085", textAlign: "center" }}>{t("home.early")}</span>
                            </Col>
                            <Col span={12} style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ color: "var(--button-color)", fontSize: "20px", fontWeight: "bold", textAlign: "center" }}>{employeeWorkInCount?.checkOutLate}</span>
                                <span style={{ color: "#667085", textAlign: "center" }}>{t("home.back_late")}</span>
                            </Col>
                        </Row>
                    </Col>
                </Flex>
            </Flex>

        </Card>
    );
}

export default EmployeeInfoTab;
